/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import UseSpecType from './UseSpecType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="version" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="container" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;sequence&gt; &lt;element name="use" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;sequence&gt; &lt;element name="useSpec" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="type" type="{}useSpecType" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="searchPath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="imports" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ancestors" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="dataSourceOverride" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="originalCMDataSource" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="overrideCMDataSource" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="overrideCatalog" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="overrideSchema" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="cmDataSource" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="catalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="schema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;element name="expressionLocale" type="{http://www.w3.org/2001/XMLSchema}language" minOccurs="0"/&gt; &lt;element name="fmModel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="lastModified" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;choice&gt; &lt;element ref="{}dataSource" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}querySubject" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}filter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}calculation" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}parameterMap" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="metadataTreeView" type="{}folderType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="metadataTreeViewFocus" type="{}focus" minOccurs="0"/&gt; &lt;element name="textResource" type="{}textResource" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}drillGroup" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}namedSet" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}parameterValueSet" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}prompt" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}whatIfModel" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}translation" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}customSort" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/choice&gt; &lt;element name="dataRetrievalMode" minOccurs="0"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="liveConnection"/&gt; &lt;enumeration value="snapShot"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="refActiveParameterValueSet" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Module extends ObjectType{

	//_objectFactory = null;

	//_flattenedObjectTypeList = null;



	version = null;

	container = null;

	use = null;

	useSpec = null;

	expressionLocale = null;

	fmModel = null;

	lastModified = null;

	dataSource = null;

	querySubject = null;

	filter = null;

	calculation = null;

	relationship = null;

	parameterMap = null;

	metadataTreeView = null;

	metadataTreeViewFocus = null;

	textResource = null;

	drillGroup = null;

	namedSet = null;

	parameterValueSet = null;

	prompt = null;

	whatIfModel = null;

	translation = null;

	customSort = null;

	dataRetrievalMode = null;

	refActiveParameterValueSet = null;

	_overrideMode = false;

	_originalVersion = 0.0;



	/**
	 * Gets the value of the version property.
	 * @return {String} possible object is {@link String}
	 */
	getVersion() {
		return this.version;
	}

	/**
	 * Sets the value of the version property.
	 * @param {String} value allowed object is {@link String}
	 */
	setVersion(value) {
		var oldValue = this.version;
		this.version = value;
		this._setAndNotify(52, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the container property.
	 * @return {String} possible object is {@link String}
	 */
	getContainer() {
		return this.container;
	}

	/**
	 * Sets the value of the container property.
	 * @param {String} value allowed object is {@link String}
	 */
	setContainer(value) {
		var oldValue = this.container;
		this.container = value;
		this._setAndNotify(53, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the use property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the use property. <p> For example, to add a new item, do as follows: <pre> getUse().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getUse() {
		if (!this.use) {
			this.use = [];
		}
		return this.use;
	}

	/**
	 * Gets the value of the useSpec property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the useSpec property. <p> For example, to add a new item, do as follows: <pre> getUseSpec().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Module.UseSpec}
	 */
	getUseSpec() {
		if (!this.useSpec) {
			this.useSpec = [];
		}
		return this.useSpec;
	}

	/**
	 * Gets the value of the expressionLocale property.
	 * @return {String} possible object is {@link String}
	 */
	getExpressionLocale() {
		return this.expressionLocale;
	}

	/**
	 * Sets the value of the expressionLocale property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpressionLocale(value) {
		var oldValue = this.expressionLocale;
		this.expressionLocale = value;
		this._setAndNotify(56, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the fmModel property.
	 * @return {String} possible object is {@link String}
	 */
	getFmModel() {
		return this.fmModel;
	}

	/**
	 * Sets the value of the fmModel property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFmModel(value) {
		var oldValue = this.fmModel;
		this.fmModel = value;
		this._setAndNotify(57, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the lastModified property.
	 * @return {String} possible object is {@link String}
	 */
	getLastModified() {
		return this.lastModified;
	}

	/**
	 * Sets the value of the lastModified property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLastModified(value) {
		var oldValue = this.lastModified;
		this.lastModified = value;
		this._setAndNotify(58, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the dataSource property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the dataSource property. <p> For example, to add a new item, do as follows: <pre> getDataSource().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DataSource}
	 */
	getDataSource() {
		if (!this.dataSource) {
			this.dataSource = [];
		}
		return this.dataSource;
	}

	/**
	 * Gets the value of the querySubject property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the querySubject property. <p> For example, to add a new item, do as follows: <pre> getQuerySubject().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject}
	 */
	getQuerySubject() {
		if (!this.querySubject) {
			this.querySubject = [];
		}
		return this.querySubject;
	}

	/**
	 * Gets the value of the filter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the filter property. <p> For example, to add a new item, do as follows: <pre> getFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Filter}
	 */
	getFilter() {
		if (!this.filter) {
			this.filter = [];
		}
		return this.filter;
	}

	/**
	 * Gets the value of the calculation property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculation property. <p> For example, to add a new item, do as follows: <pre> getCalculation().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Calculation}
	 */
	getCalculation() {
		if (!this.calculation) {
			this.calculation = [];
		}
		return this.calculation;
	}

	/**
	 * Gets the value of the relationship property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the relationship property. <p> For example, to add a new item, do as follows: <pre> getRelationship().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship}
	 */
	getRelationship() {
		if (!this.relationship) {
			this.relationship = [];
		}
		return this.relationship;
	}

	/**
	 * Gets the value of the parameterMap property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterMap property. <p> For example, to add a new item, do as follows: <pre> getParameterMap().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterMap}
	 */
	getParameterMap() {
		if (!this.parameterMap) {
			this.parameterMap = [];
		}
		return this.parameterMap;
	}

	/**
	 * Gets the value of the metadataTreeView property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the metadataTreeView property. <p> For example, to add a new item, do as follows: <pre> getMetadataTreeView().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link FolderType}
	 */
	getMetadataTreeView() {
		if (!this.metadataTreeView) {
			this.metadataTreeView = [];
		}
		return this.metadataTreeView;
	}

	/**
	 * Gets the value of the metadataTreeViewFocus property.
	 * @return {Focus} possible object is {@link Focus}
	 */
	getMetadataTreeViewFocus() {
		return this.metadataTreeViewFocus;
	}

	/**
	 * Sets the value of the metadataTreeViewFocus property.
	 * @param {Focus} value allowed object is {@link Focus}
	 */
	setMetadataTreeViewFocus(value) {
		var oldValue = this.metadataTreeViewFocus;
		this.metadataTreeViewFocus = value;
		this._setAndNotify(65, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the textResource property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the textResource property. <p> For example, to add a new item, do as follows: <pre> getTextResource().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TextResource}
	 */
	getTextResource() {
		if (!this.textResource) {
			this.textResource = [];
		}
		return this.textResource;
	}

	/**
	 * drill Information.Gets the value of the drillGroup property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the drillGroup property. <p> For example, to add a new item, do as follows: <pre> getDrillGroup().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DrillGroup}
	 */
	getDrillGroup() {
		if (!this.drillGroup) {
			this.drillGroup = [];
		}
		return this.drillGroup;
	}

	/**
	 * Gets the value of the namedSet property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the namedSet property. <p> For example, to add a new item, do as follows: <pre> getNamedSet().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link NamedSet}
	 */
	getNamedSet() {
		if (!this.namedSet) {
			this.namedSet = [];
		}
		return this.namedSet;
	}

	/**
	 * Gets the value of the parameterValueSet property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterValueSet property. <p> For example, to add a new item, do as follows: <pre> getParameterValueSet().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterValueSet}
	 */
	getParameterValueSet() {
		if (!this.parameterValueSet) {
			this.parameterValueSet = [];
		}
		return this.parameterValueSet;
	}

	/**
	 * Gets the value of the prompt property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the prompt property. <p> For example, to add a new item, do as follows: <pre> getPrompt().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Prompt}
	 */
	getPrompt() {
		if (!this.prompt) {
			this.prompt = [];
		}
		return this.prompt;
	}

	/**
	 * Gets the value of the whatIfModel property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the whatIfModel property. <p> For example, to add a new item, do as follows: <pre> getWhatIfModel().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link WhatIfModel}
	 */
	getWhatIfModel() {
		if (!this.whatIfModel) {
			this.whatIfModel = [];
		}
		return this.whatIfModel;
	}

	/**
	 * Gets the value of the translation property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the translation property. <p> For example, to add a new item, do as follows: <pre> getTranslation().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Translation}
	 */
	getTranslation() {
		if (!this.translation) {
			this.translation = [];
		}
		return this.translation;
	}

	/**
	 * Gets the value of the customSort property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the customSort property. <p> For example, to add a new item, do as follows: <pre> getCustomSort().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link CustomSort}
	 */
	getCustomSort() {
		if (!this.customSort) {
			this.customSort = [];
		}
		return this.customSort;
	}

	/**
	 * Gets the value of the dataRetrievalMode property.
	 * @return {String} possible object is {@link String}
	 */
	getDataRetrievalMode() {
		return this.dataRetrievalMode;
	}

	/**
	 * Sets the value of the dataRetrievalMode property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDataRetrievalMode(value) {
		var oldValue = this.dataRetrievalMode;
		this.dataRetrievalMode = value;
		this._setAndNotify(74, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the refActiveParameterValueSet property.
	 * @return {String} possible object is {@link String}
	 */
	getRefActiveParameterValueSet() {
		return this.refActiveParameterValueSet;
	}

	/**
	 * Sets the value of the refActiveParameterValueSet property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRefActiveParameterValueSet(value) {
		var oldValue = this.refActiveParameterValueSet;
		this.refActiveParameterValueSet = value;
		this._setAndNotify(75, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the <code>use</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetUse() {
		return this.use;
	}

	/**
	 * Gets the value of the <code>useSpec</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>UseSpec</code> elements, or <code>null</code> if not set
	 */
	basicGetUseSpec() {
		return this.useSpec;
	}

	/**
	 * Gets the value of the <code>dataSource</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>DataSource</code> elements, or <code>null</code> if not set
	 */
	basicGetDataSource() {
		return this.dataSource;
	}

	/**
	 * Gets the value of the <code>querySubject</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>QuerySubject</code> elements, or <code>null</code> if not set
	 */
	basicGetQuerySubject() {
		return this.querySubject;
	}

	/**
	 * Gets the value of the <code>filter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Filter</code> elements, or <code>null</code> if not set
	 */
	basicGetFilter() {
		return this.filter;
	}

	/**
	 * Gets the value of the <code>calculation</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Calculation</code> elements, or <code>null</code> if not set
	 */
	basicGetCalculation() {
		return this.calculation;
	}

	/**
	 * Gets the value of the <code>relationship</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Relationship</code> elements, or <code>null</code> if not set
	 */
	basicGetRelationship() {
		return this.relationship;
	}

	/**
	 * Gets the value of the <code>parameterMap</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ParameterMap</code> elements, or <code>null</code> if not set
	 */
	basicGetParameterMap() {
		return this.parameterMap;
	}

	/**
	 * Gets the value of the <code>metadataTreeView</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>FolderType</code> elements, or <code>null</code> if not set
	 */
	basicGetMetadataTreeView() {
		return this.metadataTreeView;
	}

	/**
	 * Gets the value of the <code>textResource</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>TextResource</code> elements, or <code>null</code> if not set
	 */
	basicGetTextResource() {
		return this.textResource;
	}

	/**
	 * Gets the value of the <code>drillGroup</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>DrillGroup</code> elements, or <code>null</code> if not set
	 */
	basicGetDrillGroup() {
		return this.drillGroup;
	}

	/**
	 * Gets the value of the <code>namedSet</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>NamedSet</code> elements, or <code>null</code> if not set
	 */
	basicGetNamedSet() {
		return this.namedSet;
	}

	/**
	 * Gets the value of the <code>parameterValueSet</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ParameterValueSet</code> elements, or <code>null</code> if not set
	 */
	basicGetParameterValueSet() {
		return this.parameterValueSet;
	}

	/**
	 * Gets the value of the <code>prompt</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Prompt</code> elements, or <code>null</code> if not set
	 */
	basicGetPrompt() {
		return this.prompt;
	}

	/**
	 * Gets the value of the <code>whatIfModel</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>WhatIfModel</code> elements, or <code>null</code> if not set
	 */
	basicGetWhatIfModel() {
		return this.whatIfModel;
	}

	/**
	 * Gets the value of the <code>translation</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Translation</code> elements, or <code>null</code> if not set
	 */
	basicGetTranslation() {
		return this.translation;
	}

	/**
	 * Gets the value of the <code>customSort</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>CustomSort</code> elements, or <code>null</code> if not set
	 */
	basicGetCustomSort() {
		return this.customSort;
	}

	/**
	 * True if the module is in override mode
	 */
	isOverrideMode() {
		return this._overrideMode;
	}

	/**
	 * Set the override mode
	 * @param {boolean} override true to be in override mode
	 */
	setOverrideMode(override) {
		this._overrideMode = override;
	}

	/**
	 * Get the object factory
	 */
	getObjectFactory() {
		return this._objectFactory;
	}

	/**
	 * Set the object factory
	 * @param {ObjectFactory} objFactory object factory creating module
	 */
	setObjectFactory(objFactory) {
		this._objectFactory = objFactory;
	}

	/**
	 * Return a list of flatened ObjectType objects including QuerySubject, Filters, and Calculations
	 * @return {Array} Return a list of flatened ObjectType
	 */
	getFlattenedBaseObjectTypeList() {
		return this._flattenedObjectTypeList;
	}

	/**
	 * Set the faltened ObjectType list
	 * @param {Array} objectTypeList a list of flatened ObjectType
	 */
	setFlattenedBaseObjectTypeList(objectTypeList) {
		this._flattenedObjectTypeList = objectTypeList;
	}

	/**
	 * get original version
	 */
	getOriginalVersion() {
		return this._originalVersion;
	}

	/**
	 * Set the original version
	 * @param {float} orgVersion original version
	 */
	setOriginalVersion(orgVersion) {
		this._originalVersion = orgVersion;
	}

	/**
	 * Creates a new instance of <code>Module</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Module</code> object from.
	 * @return {Module} an object of type <code>Module</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModule();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addUseAt(position, item) {
		this._addAtAndNotify(this.getUse(), position, item, 54, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addUse(item) {
		this.addUseAt(this.getUse().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeUseAt(position) {
		this._removeAtAndNotify(this.getUse(), position, 54, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeUse(item) {
		var i = this.getUse().indexOf(item);
		if (i >= 0) {
			this.removeUseAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addUseSpecAt(position, item) {
		this._addAtAndNotify(this.getUseSpec(), position, item, 55, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addUseSpec(item) {
		this.addUseSpecAt(this.getUseSpec().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeUseSpecAt(position) {
		this._removeAtAndNotify(this.getUseSpec(), position, 55, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeUseSpec(item) {
		var i = this.getUseSpec().indexOf(item);
		if (i >= 0) {
			this.removeUseSpecAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addDataSourceAt(position, item) {
		this._addAtAndNotify(this.getDataSource(), position, item, 59, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addDataSource(item) {
		this.addDataSourceAt(this.getDataSource().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeDataSourceAt(position) {
		this._removeAtAndNotify(this.getDataSource(), position, 59, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeDataSource(item) {
		var i = this.getDataSource().indexOf(item);
		if (i >= 0) {
			this.removeDataSourceAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQuerySubjectAt(position, item) {
		this._addAtAndNotify(this.getQuerySubject(), position, item, 60, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQuerySubject(item) {
		this.addQuerySubjectAt(this.getQuerySubject().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQuerySubjectAt(position) {
		this._removeAtAndNotify(this.getQuerySubject(), position, 60, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQuerySubject(item) {
		var i = this.getQuerySubject().indexOf(item);
		if (i >= 0) {
			this.removeQuerySubjectAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addFilterAt(position, item) {
		this._addAtAndNotify(this.getFilter(), position, item, 10, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addFilter(item) {
		this.addFilterAt(this.getFilter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeFilterAt(position) {
		this._removeAtAndNotify(this.getFilter(), position, 10, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeFilter(item) {
		var i = this.getFilter().indexOf(item);
		if (i >= 0) {
			this.removeFilterAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCalculationAt(position, item) {
		this._addAtAndNotify(this.getCalculation(), position, item, 61, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCalculation(item) {
		this.addCalculationAt(this.getCalculation().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCalculationAt(position) {
		this._removeAtAndNotify(this.getCalculation(), position, 61, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCalculation(item) {
		var i = this.getCalculation().indexOf(item);
		if (i >= 0) {
			this.removeCalculationAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRelationshipAt(position, item) {
		this._addAtAndNotify(this.getRelationship(), position, item, 62, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRelationship(item) {
		this.addRelationshipAt(this.getRelationship().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRelationshipAt(position) {
		this._removeAtAndNotify(this.getRelationship(), position, 62, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRelationship(item) {
		var i = this.getRelationship().indexOf(item);
		if (i >= 0) {
			this.removeRelationshipAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addParameterMapAt(position, item) {
		this._addAtAndNotify(this.getParameterMap(), position, item, 63, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addParameterMap(item) {
		this.addParameterMapAt(this.getParameterMap().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeParameterMapAt(position) {
		this._removeAtAndNotify(this.getParameterMap(), position, 63, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeParameterMap(item) {
		var i = this.getParameterMap().indexOf(item);
		if (i >= 0) {
			this.removeParameterMapAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addMetadataTreeViewAt(position, item) {
		this._addAtAndNotify(this.getMetadataTreeView(), position, item, 64, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addMetadataTreeView(item) {
		this.addMetadataTreeViewAt(this.getMetadataTreeView().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeMetadataTreeViewAt(position) {
		this._removeAtAndNotify(this.getMetadataTreeView(), position, 64, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeMetadataTreeView(item) {
		var i = this.getMetadataTreeView().indexOf(item);
		if (i >= 0) {
			this.removeMetadataTreeViewAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTextResourceAt(position, item) {
		this._addAtAndNotify(this.getTextResource(), position, item, 66, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTextResource(item) {
		this.addTextResourceAt(this.getTextResource().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTextResourceAt(position) {
		this._removeAtAndNotify(this.getTextResource(), position, 66, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTextResource(item) {
		var i = this.getTextResource().indexOf(item);
		if (i >= 0) {
			this.removeTextResourceAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addDrillGroupAt(position, item) {
		this._addAtAndNotify(this.getDrillGroup(), position, item, 67, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addDrillGroup(item) {
		this.addDrillGroupAt(this.getDrillGroup().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeDrillGroupAt(position) {
		this._removeAtAndNotify(this.getDrillGroup(), position, 67, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeDrillGroup(item) {
		var i = this.getDrillGroup().indexOf(item);
		if (i >= 0) {
			this.removeDrillGroupAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addNamedSetAt(position, item) {
		this._addAtAndNotify(this.getNamedSet(), position, item, 68, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addNamedSet(item) {
		this.addNamedSetAt(this.getNamedSet().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeNamedSetAt(position) {
		this._removeAtAndNotify(this.getNamedSet(), position, 68, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeNamedSet(item) {
		var i = this.getNamedSet().indexOf(item);
		if (i >= 0) {
			this.removeNamedSetAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addParameterValueSetAt(position, item) {
		this._addAtAndNotify(this.getParameterValueSet(), position, item, 69, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addParameterValueSet(item) {
		this.addParameterValueSetAt(this.getParameterValueSet().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeParameterValueSetAt(position) {
		this._removeAtAndNotify(this.getParameterValueSet(), position, 69, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeParameterValueSet(item) {
		var i = this.getParameterValueSet().indexOf(item);
		if (i >= 0) {
			this.removeParameterValueSetAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPromptAt(position, item) {
		this._addAtAndNotify(this.getPrompt(), position, item, 70, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addPrompt(item) {
		this.addPromptAt(this.getPrompt().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePromptAt(position) {
		this._removeAtAndNotify(this.getPrompt(), position, 70, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removePrompt(item) {
		var i = this.getPrompt().indexOf(item);
		if (i >= 0) {
			this.removePromptAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addWhatIfModelAt(position, item) {
		this._addAtAndNotify(this.getWhatIfModel(), position, item, 71, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addWhatIfModel(item) {
		this.addWhatIfModelAt(this.getWhatIfModel().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeWhatIfModelAt(position) {
		this._removeAtAndNotify(this.getWhatIfModel(), position, 71, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeWhatIfModel(item) {
		var i = this.getWhatIfModel().indexOf(item);
		if (i >= 0) {
			this.removeWhatIfModelAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTranslationAt(position, item) {
		this._addAtAndNotify(this.getTranslation(), position, item, 72, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTranslation(item) {
		this.addTranslationAt(this.getTranslation().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTranslationAt(position) {
		this._removeAtAndNotify(this.getTranslation(), position, 72, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTranslation(item) {
		var i = this.getTranslation().indexOf(item);
		if (i >= 0) {
			this.removeTranslationAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCustomSortAt(position, item) {
		this._addAtAndNotify(this.getCustomSort(), position, item, 73, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCustomSort(item) {
		this.addCustomSortAt(this.getCustomSort().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCustomSortAt(position) {
		this._removeAtAndNotify(this.getCustomSort(), position, 73, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCustomSort(item) {
		var i = this.getCustomSort().indexOf(item);
		if (i >= 0) {
			this.removeCustomSortAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Module";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 52, "version", null));
		featureList.push(this.createFeature(false, false, false, 53, "container", null));
		featureList.push(this.createFeature(true, false, false, 54, "use", null));
		var clazz;
		if (factory) {
			clazz = factory.createModuleUseSpec().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 55, "useSpec", clazz));
		featureList.push(this.createFeature(false, false, false, 56, "expressionLocale", null));
		featureList.push(this.createFeature(false, false, false, 57, "fmModel", null));
		featureList.push(this.createFeature(false, false, false, 58, "lastModified", null));
		if (factory) {
			clazz = factory.createDataSource().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 59, "dataSource", clazz));
		if (factory) {
			clazz = factory.createQuerySubject().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 60, "querySubject", clazz));
		if (factory) {
			clazz = factory.createFilter().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 10, "filter", clazz));
		if (factory) {
			clazz = factory.createCalculation().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 61, "calculation", clazz));
		if (factory) {
			clazz = factory.createRelationship().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 62, "relationship", clazz));
		if (factory) {
			clazz = factory.createParameterMap().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 63, "parameterMap", clazz));
		if (factory) {
			clazz = factory.createFolderType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 64, "metadataTreeView", clazz));
		if (factory) {
			clazz = factory.createFocus().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 65, "metadataTreeViewFocus", clazz));
		if (factory) {
			clazz = factory.createTextResource().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 66, "textResource", clazz));
		if (factory) {
			clazz = factory.createDrillGroup().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 67, "drillGroup", clazz));
		if (factory) {
			clazz = factory.createNamedSet().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 68, "namedSet", clazz));
		if (factory) {
			clazz = factory.createParameterValueSet().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 69, "parameterValueSet", clazz));
		if (factory) {
			clazz = factory.createPrompt().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 70, "prompt", clazz));
		if (factory) {
			clazz = factory.createWhatIfModel().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 71, "whatIfModel", clazz));
		if (factory) {
			clazz = factory.createTranslation().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 72, "translation", clazz));
		if (factory) {
			clazz = factory.createCustomSort().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 73, "customSort", clazz));
		featureList.push(this.createFeature(false, false, false, 74, "dataRetrievalMode", null));
		featureList.push(this.createFeature(false, false, false, 75, "refActiveParameterValueSet", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 52:
			this.setVersion((value));
			break;
		case 53:
			this.setContainer((value));
			break;
		case 56:
			this.setExpressionLocale((value));
			break;
		case 57:
			this.setFmModel((value));
			break;
		case 58:
			this.setLastModified((value));
			break;
		case 65:
			this.setMetadataTreeViewFocus((value));
			break;
		case 74:
			this.setDataRetrievalMode((value));
			break;
		case 75:
			this.setRefActiveParameterValueSet((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 54:
			this.use = (value);
			break;
		case 55:
			this.useSpec = (value);
			break;
		case 59:
			this.dataSource = (value);
			break;
		case 60:
			this.querySubject = (value);
			break;
		case 10:
			this.filter = (value);
			break;
		case 61:
			this.calculation = (value);
			break;
		case 62:
			this.relationship = (value);
			break;
		case 63:
			this.parameterMap = (value);
			break;
		case 64:
			this.metadataTreeView = (value);
			break;
		case 66:
			this.textResource = (value);
			break;
		case 67:
			this.drillGroup = (value);
			break;
		case 68:
			this.namedSet = (value);
			break;
		case 69:
			this.parameterValueSet = (value);
			break;
		case 70:
			this.prompt = (value);
			break;
		case 71:
			this.whatIfModel = (value);
			break;
		case 72:
			this.translation = (value);
			break;
		case 73:
			this.customSort = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 52:
			return this.getVersion();
		case 53:
			return this.getContainer();
		case 54:
			return this.getUse();
		case 55:
			return this.getUseSpec();
		case 56:
			return this.getExpressionLocale();
		case 57:
			return this.getFmModel();
		case 58:
			return this.getLastModified();
		case 59:
			return this.getDataSource();
		case 60:
			return this.getQuerySubject();
		case 10:
			return this.getFilter();
		case 61:
			return this.getCalculation();
		case 62:
			return this.getRelationship();
		case 63:
			return this.getParameterMap();
		case 64:
			return this.getMetadataTreeView();
		case 65:
			return this.getMetadataTreeViewFocus();
		case 66:
			return this.getTextResource();
		case 67:
			return this.getDrillGroup();
		case 68:
			return this.getNamedSet();
		case 69:
			return this.getParameterValueSet();
		case 70:
			return this.getPrompt();
		case 71:
			return this.getWhatIfModel();
		case 72:
			return this.getTranslation();
		case 73:
			return this.getCustomSort();
		case 74:
			return this.getDataRetrievalMode();
		case 75:
			return this.getRefActiveParameterValueSet();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 52:
			return this.getVersion();
		case 53:
			return this.getContainer();
		case 54:
			return this.basicGetUse();
		case 55:
			return this.basicGetUseSpec();
		case 56:
			return this.getExpressionLocale();
		case 57:
			return this.getFmModel();
		case 58:
			return this.getLastModified();
		case 59:
			return this.basicGetDataSource();
		case 60:
			return this.basicGetQuerySubject();
		case 10:
			return this.basicGetFilter();
		case 61:
			return this.basicGetCalculation();
		case 62:
			return this.basicGetRelationship();
		case 63:
			return this.basicGetParameterMap();
		case 64:
			return this.basicGetMetadataTreeView();
		case 65:
			return this.getMetadataTreeViewFocus();
		case 66:
			return this.basicGetTextResource();
		case 67:
			return this.basicGetDrillGroup();
		case 68:
			return this.basicGetNamedSet();
		case 69:
			return this.basicGetParameterValueSet();
		case 70:
			return this.basicGetPrompt();
		case 71:
			return this.basicGetWhatIfModel();
		case 72:
			return this.basicGetTranslation();
		case 73:
			return this.basicGetCustomSort();
		case 74:
			return this.getDataRetrievalMode();
		case 75:
			return this.getRefActiveParameterValueSet();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 54:
			this.addUseAt(position, (value));
			break;
		case 55:
			this.addUseSpecAt(position, (value));
			break;
		case 59:
			this.addDataSourceAt(position, (value));
			break;
		case 60:
			this.addQuerySubjectAt(position, (value));
			break;
		case 10:
			this.addFilterAt(position, (value));
			break;
		case 61:
			this.addCalculationAt(position, (value));
			break;
		case 62:
			this.addRelationshipAt(position, (value));
			break;
		case 63:
			this.addParameterMapAt(position, (value));
			break;
		case 64:
			this.addMetadataTreeViewAt(position, (value));
			break;
		case 66:
			this.addTextResourceAt(position, (value));
			break;
		case 67:
			this.addDrillGroupAt(position, (value));
			break;
		case 68:
			this.addNamedSetAt(position, (value));
			break;
		case 69:
			this.addParameterValueSetAt(position, (value));
			break;
		case 70:
			this.addPromptAt(position, (value));
			break;
		case 71:
			this.addWhatIfModelAt(position, (value));
			break;
		case 72:
			this.addTranslationAt(position, (value));
			break;
		case 73:
			this.addCustomSortAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 54:
			this.addUse((value));
			break;
		case 55:
			this.addUseSpec((value));
			break;
		case 59:
			this.addDataSource((value));
			break;
		case 60:
			this.addQuerySubject((value));
			break;
		case 10:
			this.addFilter((value));
			break;
		case 61:
			this.addCalculation((value));
			break;
		case 62:
			this.addRelationship((value));
			break;
		case 63:
			this.addParameterMap((value));
			break;
		case 64:
			this.addMetadataTreeView((value));
			break;
		case 66:
			this.addTextResource((value));
			break;
		case 67:
			this.addDrillGroup((value));
			break;
		case 68:
			this.addNamedSet((value));
			break;
		case 69:
			this.addParameterValueSet((value));
			break;
		case 70:
			this.addPrompt((value));
			break;
		case 71:
			this.addWhatIfModel((value));
			break;
		case 72:
			this.addTranslation((value));
			break;
		case 73:
			this.addCustomSort((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 54:
			this.removeUseAt(position);
			break;
		case 55:
			this.removeUseSpecAt(position);
			break;
		case 59:
			this.removeDataSourceAt(position);
			break;
		case 60:
			this.removeQuerySubjectAt(position);
			break;
		case 10:
			this.removeFilterAt(position);
			break;
		case 61:
			this.removeCalculationAt(position);
			break;
		case 62:
			this.removeRelationshipAt(position);
			break;
		case 63:
			this.removeParameterMapAt(position);
			break;
		case 64:
			this.removeMetadataTreeViewAt(position);
			break;
		case 66:
			this.removeTextResourceAt(position);
			break;
		case 67:
			this.removeDrillGroupAt(position);
			break;
		case 68:
			this.removeNamedSetAt(position);
			break;
		case 69:
			this.removeParameterValueSetAt(position);
			break;
		case 70:
			this.removePromptAt(position);
			break;
		case 71:
			this.removeWhatIfModelAt(position);
			break;
		case 72:
			this.removeTranslationAt(position);
			break;
		case 73:
			this.removeCustomSortAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 54:
			this.removeUse((item));
			break;
		case 55:
			this.removeUseSpec((item));
			break;
		case 59:
			this.removeDataSource((item));
			break;
		case 60:
			this.removeQuerySubject((item));
			break;
		case 10:
			this.removeFilter((item));
			break;
		case 61:
			this.removeCalculation((item));
			break;
		case 62:
			this.removeRelationship((item));
			break;
		case 63:
			this.removeParameterMap((item));
			break;
		case 64:
			this.removeMetadataTreeView((item));
			break;
		case 66:
			this.removeTextResource((item));
			break;
		case 67:
			this.removeDrillGroup((item));
			break;
		case 68:
			this.removeNamedSet((item));
			break;
		case 69:
			this.removeParameterValueSet((item));
			break;
		case 70:
			this.removePrompt((item));
			break;
		case 71:
			this.removeWhatIfModel((item));
			break;
		case 72:
			this.removeTranslation((item));
			break;
		case 73:
			this.removeCustomSort((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="type" type="{}useSpecType" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="searchPath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="imports" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ancestors" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="dataSourceOverride" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="originalCMDataSource" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="overrideCMDataSource" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="overrideCatalog" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="overrideSchema" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="cmDataSource" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="catalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="schema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Module.UseSpec = class extends MoserObject{

	identifier = null;

	type = null;

	storeID = null;

	searchPath = null;

	imports = null;

	ancestors = null;

	dataCacheExpiry = null;

	property = null;

	dataSourceOverride = null;



	/**
	 * Gets the value of the identifier property.
	 * @return {String} possible object is {@link String}
	 */
	getIdentifier() {
		return this.identifier;
	}

	/**
	 * Sets the value of the identifier property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdentifier(value) {
		var oldValue = this.identifier;
		this.identifier = value;
		this._setAndNotify(91, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the type property.
	 * @return {UseSpecType} possible object is {@link UseSpecType}
	 */
	getType() {
		return this.type;
	}

	/**
	 * Sets the value of the type property.
	 * @param {UseSpecType} value allowed object is {@link UseSpecType}
	 */
	setType(value) {
		var oldValue = this.type;
		this.type = value;
		this._setAndNotify(83, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the storeID property.
	 * @return {String} possible object is {@link String}
	 */
	getStoreID() {
		return this.storeID;
	}

	/**
	 * Sets the value of the storeID property.
	 * @param {String} value allowed object is {@link String}
	 */
	setStoreID(value) {
		var oldValue = this.storeID;
		this.storeID = value;
		this._setAndNotify(92, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the searchPath property.
	 * @return {String} possible object is {@link String}
	 */
	getSearchPath() {
		return this.searchPath;
	}

	/**
	 * Sets the value of the searchPath property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSearchPath(value) {
		var oldValue = this.searchPath;
		this.searchPath = value;
		this._setAndNotify(93, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the imports property.
	 * @return {String} possible object is {@link String}
	 */
	getImports() {
		return this.imports;
	}

	/**
	 * Sets the value of the imports property.
	 * @param {String} value allowed object is {@link String}
	 */
	setImports(value) {
		var oldValue = this.imports;
		this.imports = value;
		this._setAndNotify(94, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the ancestors property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ancestors property. <p> For example, to add a new item, do as follows: <pre> getAncestors().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Module.UseSpec.Ancestors}
	 */
	getAncestors() {
		if (!this.ancestors) {
			this.ancestors = [];
		}
		return this.ancestors;
	}

	/**
	 * Gets the value of the dataCacheExpiry property.
	 * @return {String} possible object is {@link String}
	 */
	getDataCacheExpiry() {
		return this.dataCacheExpiry;
	}

	/**
	 * Sets the value of the dataCacheExpiry property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDataCacheExpiry(value) {
		var oldValue = this.dataCacheExpiry;
		this.dataCacheExpiry = value;
		this._setAndNotify(27, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the property property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the property property. <p> For example, to add a new item, do as follows: <pre> getProperty().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PropertyType}
	 */
	getProperty() {
		if (!this.property) {
			this.property = [];
		}
		return this.property;
	}

	/**
	 * Gets the value of the dataSourceOverride property.
	 * @return {DataSourceOverride} possible object is {@link Module.UseSpec.DataSourceOverride}
	 */
	getDataSourceOverride() {
		return this.dataSourceOverride;
	}

	/**
	 * Sets the value of the dataSourceOverride property.
	 * @param {DataSourceOverride} value allowed object is {@link Module.UseSpec.DataSourceOverride}
	 */
	setDataSourceOverride(value) {
		var oldValue = this.dataSourceOverride;
		this.dataSourceOverride = value;
		this._setAndNotify(97, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the <code>ancestors</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Ancestors</code> elements, or <code>null</code> if not set
	 */
	basicGetAncestors() {
		return this.ancestors;
	}

	/**
	 * Gets the value of the <code>property</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>PropertyType</code> elements, or <code>null</code> if not set
	 */
	basicGetProperty() {
		return this.property;
	}

	/**
	 * Creates a new instance of <code>UseSpec</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> UseSpec</code> object from.
	 * @return {UseSpec} an object of type <code>UseSpec</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModuleUseSpec();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addAncestorsAt(position, item) {
		this._addAtAndNotify(this.getAncestors(), position, item, 95, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addAncestors(item) {
		this.addAncestorsAt(this.getAncestors().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeAncestorsAt(position) {
		this._removeAtAndNotify(this.getAncestors(), position, 95, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeAncestors(item) {
		var i = this.getAncestors().indexOf(item);
		if (i >= 0) {
			this.removeAncestorsAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyAt(position, item) {
		this._addAtAndNotify(this.getProperty(), position, item, 96, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addProperty(item) {
		this.addPropertyAt(this.getProperty().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePropertyAt(position) {
		this._removeAtAndNotify(this.getProperty(), position, 96, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeProperty(item) {
		var i = this.getProperty().indexOf(item);
		if (i >= 0) {
			this.removePropertyAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "UseSpec";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 91, "identifier", null));
		featureList.push(this.createFeature(false, true, false, 83, "type", UseSpecType));
		featureList.push(this.createFeature(false, false, false, 92, "storeID", null));
		featureList.push(this.createFeature(false, false, false, 93, "searchPath", null));
		featureList.push(this.createFeature(false, false, false, 94, "imports", null));
		var clazz;
		if (factory) {
			clazz = factory.createModuleUseSpecAncestors().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 95, "ancestors", clazz));
		featureList.push(this.createFeature(false, false, false, 27, "dataCacheExpiry", null));
		if (factory) {
			clazz = factory.createPropertyType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 96, "property", clazz));
		if (factory) {
			clazz = factory.createModuleUseSpecDataSourceOverride().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 97, "dataSourceOverride", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 91:
			this.setIdentifier((value));
			break;
		case 83:
			this.setType((value));
			break;
		case 92:
			this.setStoreID((value));
			break;
		case 93:
			this.setSearchPath((value));
			break;
		case 94:
			this.setImports((value));
			break;
		case 27:
			this.setDataCacheExpiry((value));
			break;
		case 97:
			this.setDataSourceOverride((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 95:
			this.ancestors = (value);
			break;
		case 96:
			this.property = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 91:
			return this.getIdentifier();
		case 83:
			return this.getType();
		case 92:
			return this.getStoreID();
		case 93:
			return this.getSearchPath();
		case 94:
			return this.getImports();
		case 95:
			return this.getAncestors();
		case 27:
			return this.getDataCacheExpiry();
		case 96:
			return this.getProperty();
		case 97:
			return this.getDataSourceOverride();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 91:
			return this.getIdentifier();
		case 83:
			return this.getType();
		case 92:
			return this.getStoreID();
		case 93:
			return this.getSearchPath();
		case 94:
			return this.getImports();
		case 95:
			return this.basicGetAncestors();
		case 27:
			return this.getDataCacheExpiry();
		case 96:
			return this.basicGetProperty();
		case 97:
			return this.getDataSourceOverride();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 95:
			this.addAncestorsAt(position, (value));
			break;
		case 96:
			this.addPropertyAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 95:
			this.addAncestors((value));
			break;
		case 96:
			this.addProperty((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 95:
			this.removeAncestorsAt(position);
			break;
		case 96:
			this.removePropertyAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 95:
			this.removeAncestors((item));
			break;
		case 96:
			this.removeProperty((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Module.UseSpec.Ancestors = class extends MoserObject{

	defaultName = null;

	storeID = null;



	/**
	 * Gets the value of the defaultName property.
	 * @return {String} possible object is {@link String}
	 */
	getDefaultName() {
		return this.defaultName;
	}

	/**
	 * Sets the value of the defaultName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDefaultName(value) {
		var oldValue = this.defaultName;
		this.defaultName = value;
		this._setAndNotify(288, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the storeID property.
	 * @return {String} possible object is {@link String}
	 */
	getStoreID() {
		return this.storeID;
	}

	/**
	 * Sets the value of the storeID property.
	 * @param {String} value allowed object is {@link String}
	 */
	setStoreID(value) {
		var oldValue = this.storeID;
		this.storeID = value;
		this._setAndNotify(92, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Ancestors</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Ancestors</code> object from.
	 * @return {Ancestors} an object of type <code>Ancestors</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModuleUseSpecAncestors();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Ancestors";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 288, "defaultName", null));
		featureList.push(this.createFeature(false, false, false, 92, "storeID", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 288:
			this.setDefaultName((value));
			break;
		case 92:
			this.setStoreID((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 288:
			return this.getDefaultName();
		case 92:
			return this.getStoreID();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 288:
			return this.getDefaultName();
		case 92:
			return this.getStoreID();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="originalCMDataSource" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="overrideCMDataSource" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="overrideCatalog" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="overrideSchema" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="cmDataSource" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="catalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="schema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Module.UseSpec.DataSourceOverride = class extends MoserObject{

	originalCMDataSource = null;

	originalCatalog = null;

	originalSchema = null;

	overrideCMDataSource = null;

	overrideCatalog = null;

	overrideSchema = null;

	cmDataSource = null;

	catalog = null;

	schema = null;



	/**
	 * Gets the value of the originalCMDataSource property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalCMDataSource() {
		if (this.originalCMDataSource == null) {
			return "";
		}
		return this.originalCMDataSource;
	}

	/**
	 * Sets the value of the originalCMDataSource property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalCMDataSource(value) {
		var oldValue = this.originalCMDataSource;
		this.originalCMDataSource = value;
		this._setAndNotify(289, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the originalCatalog property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalCatalog() {
		if (this.originalCatalog == null) {
			return "";
		}
		return this.originalCatalog;
	}

	/**
	 * Sets the value of the originalCatalog property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalCatalog(value) {
		var oldValue = this.originalCatalog;
		this.originalCatalog = value;
		this._setAndNotify(290, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the originalSchema property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalSchema() {
		if (this.originalSchema == null) {
			return "";
		}
		return this.originalSchema;
	}

	/**
	 * Sets the value of the originalSchema property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalSchema(value) {
		var oldValue = this.originalSchema;
		this.originalSchema = value;
		this._setAndNotify(291, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the overrideCMDataSource property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isOverrideCMDataSource() {
		if (this.overrideCMDataSource == null) {
			return false;
		}
		return this.overrideCMDataSource;
	}

	/**
	 * Sets the value of the overrideCMDataSource property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setOverrideCMDataSource(value) {
		var oldValue = this.overrideCMDataSource;
		this.overrideCMDataSource = value;
		this._setAndNotify(292, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the overrideCatalog property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isOverrideCatalog() {
		if (this.overrideCatalog == null) {
			return false;
		}
		return this.overrideCatalog;
	}

	/**
	 * Sets the value of the overrideCatalog property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setOverrideCatalog(value) {
		var oldValue = this.overrideCatalog;
		this.overrideCatalog = value;
		this._setAndNotify(293, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the overrideSchema property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isOverrideSchema() {
		if (this.overrideSchema == null) {
			return false;
		}
		return this.overrideSchema;
	}

	/**
	 * Sets the value of the overrideSchema property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setOverrideSchema(value) {
		var oldValue = this.overrideSchema;
		this.overrideSchema = value;
		this._setAndNotify(294, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cmDataSource property.
	 * @return {String} possible object is {@link String}
	 */
	getCmDataSource() {
		if (this.cmDataSource == null) {
			return "";
		}
		return this.cmDataSource;
	}

	/**
	 * Sets the value of the cmDataSource property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCmDataSource(value) {
		var oldValue = this.cmDataSource;
		this.cmDataSource = value;
		this._setAndNotify(104, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the catalog property.
	 * @return {String} possible object is {@link String}
	 */
	getCatalog() {
		if (this.catalog == null) {
			return "";
		}
		return this.catalog;
	}

	/**
	 * Sets the value of the catalog property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCatalog(value) {
		var oldValue = this.catalog;
		this.catalog = value;
		this._setAndNotify(111, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the schema property.
	 * @return {String} possible object is {@link String}
	 */
	getSchema() {
		if (this.schema == null) {
			return "";
		}
		return this.schema;
	}

	/**
	 * Sets the value of the schema property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSchema(value) {
		var oldValue = this.schema;
		this.schema = value;
		this._setAndNotify(112, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>DataSourceOverride</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> DataSourceOverride</code> object from.
	 * @return {DataSourceOverride} an object of type <code>DataSourceOverride</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModuleUseSpecDataSourceOverride();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "DataSourceOverride";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 289, "originalCMDataSource", null));
		featureList.push(this.createFeature(false, false, false, 290, "originalCatalog", null));
		featureList.push(this.createFeature(false, false, false, 291, "originalSchema", null));
		featureList.push(this.createFeature(false, false, false, 292, "overrideCMDataSource", null));
		featureList.push(this.createFeature(false, false, false, 293, "overrideCatalog", null));
		featureList.push(this.createFeature(false, false, false, 294, "overrideSchema", null));
		featureList.push(this.createFeature(false, false, false, 104, "cmDataSource", null));
		featureList.push(this.createFeature(false, false, false, 111, "catalog", null));
		featureList.push(this.createFeature(false, false, false, 112, "schema", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 289:
			this.setOriginalCMDataSource((value));
			break;
		case 290:
			this.setOriginalCatalog((value));
			break;
		case 291:
			this.setOriginalSchema((value));
			break;
		case 292:
			this.setOverrideCMDataSource((value));
			break;
		case 293:
			this.setOverrideCatalog((value));
			break;
		case 294:
			this.setOverrideSchema((value));
			break;
		case 104:
			this.setCmDataSource((value));
			break;
		case 111:
			this.setCatalog((value));
			break;
		case 112:
			this.setSchema((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 289:
			return this.getOriginalCMDataSource();
		case 290:
			return this.getOriginalCatalog();
		case 291:
			return this.getOriginalSchema();
		case 292:
			return this.isOverrideCMDataSource();
		case 293:
			return this.isOverrideCatalog();
		case 294:
			return this.isOverrideSchema();
		case 104:
			return this.getCmDataSource();
		case 111:
			return this.getCatalog();
		case 112:
			return this.getSchema();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 289:
			return this.getOriginalCMDataSource();
		case 290:
			return this.getOriginalCatalog();
		case 291:
			return this.getOriginalSchema();
		case 292:
			return this.isOverrideCMDataSource();
		case 293:
			return this.isOverrideCatalog();
		case 294:
			return this.isOverrideSchema();
		case 104:
			return this.getCmDataSource();
		case 111:
			return this.getCatalog();
		case 112:
			return this.getSchema();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Module.js